import { configureStore } from "@reduxjs/toolkit";
import productsReducer from "./slices/productSlice";
import cartReducer from "./slices/cartSlice";
import wishListReducer from "./slices/wishListSlice";
import { apiMiddleware } from "./middleware/api";
import { logger } from "./middleware/logger";
import { func } from "./middleware/func";

export const store = configureStore({
  reducer: {
    products: productsReducer,
    cartItems: cartReducer,
    wishList: wishListReducer,
  },
  // if we donot give any middleware it wont give error , because by defult thunk middleware will beused
  //  middleware:()=>[]// it  give error , because default middle ware is overwritten by empty array of middleware
  //middleware:()=>[api]// it  give error , because default middle ware is overwritten and we are also not using our func middleware to hande funciton in dispatch
  // if we want our middleware also to be used with preserving default thunk middleware
  // middleware: (getDefaultMiddleware) => [...getDefaultMiddleware(), logger, func]// it wont give error, here both default thunk middleware and our fun middleware is used

  // middleware:()=>[func] // here it wont give error, because though, thunk middleware is overwritten, we are using our own middleware func that acts like thunk
  middleware: (getDefaultMiddleware) => [...getDefaultMiddleware(), logger],
});
